import _ from 'lodash';
import { BaseController } from '../../common/base/controller';

export class ResetPasswordController extends BaseController {
  constructor(controllerService, loginService, $scope) {
    'ngInject';
    super({ controllerService, loginService, $scope });
  }

  $onInit() {
    this.passwordRequirementsFulfilled = true;
    this.user = _.escape(this.$stateParams.user);
    this.credentials = {
      resetToken: this.$stateParams.token,
      password: '',
    };

    this.passwordRepeatErrors = {
      required: 'app.login.form.password.message.required',
      notMatch: 'app.login.form.password.message.repeatNotMatch',
    };

    // UUID valid regex: https://stackoverflow.com/questions/7905929/how-to-test-valid-uuid-guid
    const regex = new RegExp(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
    );
    if (!regex.test(this.credentials.resetToken)) {
      this.errorMessage = 'app.admin.reset.password.invalidUUID';
    }
    if (_.isEmpty(this.user)) {
      this.errorMessage = 'app.admin.reset.password.invalidUser';
    }
  }

  submit() {
    const passwordMatches = this.credentials.password == this.passwordRepeat;
    this.resetPasswordForm.passwordRepeat.$setValidity(
      'notMatch',
      passwordMatches,
    );
    if (!passwordMatches) return;

    this.errorDetails = false;
    this.errorMessage = false;

    this.loginService
      .resetPassword(this.credentials, this.userRepeat)
      .busy(this, 'isSubmitBusy')
      .then(this.success.bind(this))
      .catch(this.handleError.bind(this));
  }

  success() {
    delete this.errorMessage;
    this.successMessage = 'reset.password.success';
  }

  goToLogin() {
    this.$window.location.href = '/';
  }

  requirementsCheck(valid) {
    this.passwordRequirementsFulfilled = valid;
  }

  handleError(errorResp) {
    const { message, error, errorDetails } = errorResp.data;
    switch (errorResp.status) {
      case 400:
      case 404: {
        this.errorDetails = errorDetails;

        if (error) {
          this.errorMessage = error;
          break;
        }

        if (message === 'UserMismatch') {
          this.errorMessage = 'UserMismatch';
          break;
        }
        this.errorMessage = 'reset.password.error.400.bad.request';
        break;
      }
      case 401: {
        this.errorMessage = 'reset.password.error.401.token.expired';
        break;
      }
      case 403: {
        this.errorMessage = 'reset.password.error.403.bad.password';
        break;
      }
      case 409: {
        this.errorMessage = 'reset.password.error.409.already-used';
        break;
      }
      case 500:
      default: {
        this.errorMessage = 'app.error.unknown';
        break;
      }
    }

    return this.$q.reject(error);
  }
}
